import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Select from 'react-select';

import 'react-select/dist/react-select.css';
import './SelectField.scss';


export default class SelectField extends Component {
    _renderArrow () {
        return (<div className='select-arrow'>{'\u25be'}</div>);
    }

    _getWrapperClasses () {
        const attributes = {
            required: 'required',
            hidden: 'hidden',
            colClass: this.props.colClass,
            hasError: 'has-error'
        };

        return Object.keys(attributes).reduce(
            (result, key) => {
                if (this.props[key]) {
                    result.push(attributes[key]);
                }
                return result;
            },
            []
        ).join(' ');
    }

    render () {
        const clearButton = (
            <div className="hasValue">
                <a className="clearBtn">×</a>
            </div>
        );
        return (
            <div className={this._getWrapperClasses()}>
                <label>{this.props.label} {(this.props.required) ? '*' : ''}</label>
                <Select
                    {...this.props}
                    clearable={true}
                    clearRenderer={() => clearButton}
                    arrowRenderer={() => this._renderArrow()}
                />
            </div>
        );
    }
}

SelectField.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,
    hidden: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string.isRequired,
    required: PropTypes.bool,
    value: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/SelectField.jsx